import { render, staticRenderFns } from "./tcDivideManagerAirCondition.vue?vue&type=template&id=22db6993&"
import script from "./tcDivideManagerAirCondition.vue?vue&type=script&lang=js&"
export * from "./tcDivideManagerAirCondition.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports